(() => {
  const shippingPattern = /shipping|delivery|postal|postcode|zip code|country|province|state/i;
  const taggedErrors = new Set();
  const recentEvents = new Map();

  const send = (stage, details = {}) => {
    if (typeof window.clarity !== 'function') return;

    const signature = `${stage}:${JSON.stringify(details)}`;
    const now = Date.now();
    if (now - (recentEvents.get(signature) || 0) < 1500) return;
    recentEvents.set(signature, now);

    window.clarity('event', stage);
    window.clarity('set', 'funnel_stage', stage);
    window.clarity('set', stage, 'true');

    Object.entries(details).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      window.clarity('set', `funnel_${key}`, String(value).slice(0, 255));
    });
  };

  const checkoutSource = (element) => {
    if (element.closest('cart-drawer')) return 'cart_drawer';
    if (element.closest('.shopify-payment-button')) return 'dynamic_checkout';
    if (window.location.pathname === '/cart') return 'cart_page';
    return 'storefront';
  };

  const trackCheckout = (element) => {
    send('begin_checkout', { source: checkoutSource(element) });
  };

  const inspectShippingError = (element) => {
    if (!(element instanceof Element)) return;
    const errorElement = element.matches('[role="alert"], .errors, .field__message, .cart-errors')
      ? element
      : element.querySelector('[role="alert"], .errors, .field__message, .cart-errors');

    if (!errorElement || errorElement.hidden) return;
    const message = errorElement.textContent.trim();
    if (!message || !shippingPattern.test(message) || taggedErrors.has(message)) return;

    taggedErrors.add(message);
    send('shipping_error', { page: window.location.pathname });
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      send('select_variant', { variant_id: data?.variant?.id });
    });

    subscribe(PUB_SUB_EVENTS.cartUpdate, ({ source, productVariantId }) => {
      if (source !== 'product-form') return;
      send('add_to_cart', { variant_id: productVariantId });
    });

    subscribe(PUB_SUB_EVENTS.cartError, ({ errors, message }) => {
      send('add_to_cart_error');
      if (shippingPattern.test(`${errors || ''} ${message || ''}`)) {
        send('shipping_error', { page: window.location.pathname });
      }
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const checkout = event.target.closest(
        '[name="checkout"], a[href*="/checkout"], .shopify-payment-button, [data-testid="Checkout-button"]'
      );
      if (checkout) trackCheckout(checkout);
    },
    true
  );

  document.addEventListener(
    'submit',
    (event) => {
      const submitter = event.submitter;
      if (submitter?.name === 'checkout' || submitter?.closest('.shopify-payment-button')) {
        trackCheckout(submitter);
      }
    },
    true
  );

  document.querySelectorAll('[role="alert"], .errors, .field__message, .cart-errors').forEach(inspectShippingError);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target instanceof Element) inspectShippingError(mutation.target);
      mutation.addedNodes.forEach(inspectShippingError);
    });
  });

  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
})();
